(function () {

document.addEventListener("DOMContentLoaded", function() {
    // Sticky Header
    const header = document.querySelector('.site-header');
    const scrollThreshold = 1;
    function updateHeaderClass() {
        if (!header) return; // Guard clause for page editor
        if (window.scrollY > scrollThreshold) header.classList.add("scrolled");
        else header.classList.remove("scrolled");
    }
    // Check on page load
    updateHeaderClass();
    // Check on scroll
    document.addEventListener("scroll", updateHeaderClass);
    // Mobile Navigation
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');
    const body = document.body;
    if (mobileMenuToggle && mobileMenu) {
        // Toggle mobile menu
        mobileMenuToggle.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            // Update ARIA attributes
            this.setAttribute('aria-expanded', !isExpanded);
            mobileMenu.setAttribute('aria-hidden', isExpanded);
            // Toggle body scroll lock
            if (!isExpanded) {
                // Focus first menu item
                const firstMenuItem = mobileMenu.querySelector('a');
                if (firstMenuItem) firstMenuItem.focus();
            } else // Return focus to toggle button
            this.focus();
        });
        // Close mobile menu when clicking outside
        mobileMenu.addEventListener('click', function(e) {
            if (e.target === mobileMenu) closeMobileMenu();
        });
        // Close mobile menu with Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mobileMenu.getAttribute('aria-hidden') === 'false') closeMobileMenu();
        });
        // Close mobile menu when clicking on menu links
        const mobileMenuLinks = mobileMenu.querySelectorAll('a');
        mobileMenuLinks.forEach((link)=>{
            link.addEventListener('click', function() {
                closeMobileMenu();
            });
        });
        // Close mobile menu function
        function closeMobileMenu() {
            mobileMenuToggle.setAttribute('aria-expanded', 'false');
            mobileMenu.setAttribute('aria-hidden', 'true');
            body.style.overflow = '';
            mobileMenuToggle.focus();
        }
        // Handle window resize
        window.addEventListener('resize', function() {
            if (window.innerWidth > 768) closeMobileMenu();
        });
    }
});


// Smooth scroll to element on page load if hash exists in URL
document.addEventListener('DOMContentLoaded', ()=>{
    const hash = window.location.hash;
    if (hash) {
        const targetId = hash.substring(1); // Remove '#' from the hash
        const targetElement = document.getElementById(targetId);
        if (targetElement) setTimeout(()=>{
            $281115d14a90ae1c$var$scrollToTarget(targetElement);
            // Open the accordion if it's a collapsible section
            if (targetElement.classList.contains('accordion-collapse')) {
                targetElement.classList.add('show'); // Open the accordion
                const button = document.querySelector(`[data-bs-target="#${targetId}"]`);
                if (button) button.classList.remove('collapsed'); // Ensure the button state is correct
            }
        }, 0); // Delay to ensure DOM is ready
    }
});
// Smooth scroll to clicked anchor link
function $281115d14a90ae1c$var$handleAnchorClick(e) {
    const targetUrl = this.getAttribute('href');
    console.log('Anchor clicked:', targetUrl);
    console.log('Current page:', window.location.href);
    if ($281115d14a90ae1c$var$isSamePageAnchor(targetUrl)) {
        console.log('Same page detected, preventing default');
        e.preventDefault(); // Prevent default anchor behavior
        const targetId = targetUrl.substring(targetUrl.indexOf('#') + 1);
        console.log('Target ID:', targetId);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            console.log('Target element found, scrolling');
            $281115d14a90ae1c$var$scrollToTarget(targetElement);
            // Open the accordion if it's a collapsible section
            if (targetElement.classList.contains('accordion-collapse')) {
                targetElement.classList.add('show'); // Open the accordion
                const button = document.querySelector(`[data-bs-target="#${targetId}"]`);
                if (button) button.classList.remove('collapsed'); // Ensure the button state is correct
            }
            // Close the menu if it's a navigation link
            if (this.classList.contains('nav-link') || this.closest('.navbar-nav')) $281115d14a90ae1c$var$collapseMenu();
        } else console.log('Target element not found for ID:', targetId);
    } else console.log('Different page, allowing normal navigation');
}
// Add event listeners to existing anchor links
document.querySelectorAll('a[href*="#"]').forEach((anchor)=>{
    anchor.addEventListener('click', $281115d14a90ae1c$var$handleAnchorClick);
});
// Also handle dynamically added menu items (for dropdowns that might be added after page load)
document.addEventListener('click', function(e) {
    if (e.target.matches('a[href*="#"]')) $281115d14a90ae1c$var$handleAnchorClick.call(e.target, e);
});
// Function to scroll to target element smoothly
function $281115d14a90ae1c$var$scrollToTarget(target) {
    target.scrollIntoView({
        behavior: 'smooth'
    });
}
// Function to check if the anchor is on the same page
function $281115d14a90ae1c$var$isSamePageAnchor(anchorUrl) {
    // Get the current page URL
    const currentUrl = new URL(window.location.href);
    const currentPath = currentUrl.pathname.replace(/\/$/, ''); // Remove trailing slash
    // Get the target URL
    const targetUrl = new URL(anchorUrl, window.location.origin);
    const targetPath = targetUrl.pathname.replace(/\/$/, ''); // Remove trailing slash
    // A different query string needs a page load before scrolling to the anchor
    return currentUrl.origin === targetUrl.origin && currentPath === targetPath && currentUrl.search === targetUrl.search;
}
// Function to collapse the mobile menu and close dropdowns
function $281115d14a90ae1c$var$collapseMenu() {
    // Close mobile menu
    const body = document.body;
    const hamburger = document.querySelector('.hamburger');
    const mobileMenu = document.querySelector('.main-menu-mobile');
    const navbarToggler = document.querySelector('.navbar-toggler');
    if (body) body.classList.remove('menu-active');
    if (hamburger) hamburger.classList.remove('is-active');
    if (mobileMenu) mobileMenu.classList.remove('show');
    if (navbarToggler) {
        navbarToggler.classList.remove('collapse');
        navbarToggler.classList.remove('is-active');
        navbarToggler.classList.add('collapsed');
    }
    // Close Bootstrap dropdowns
    const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
    dropdownMenus.forEach((dropdown)=>{
        dropdown.classList.remove('show');
    });
    // Close Bootstrap offcanvas
    const offcanvas = document.querySelector('.offcanvas.show');
    if (offcanvas) {
        const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvas);
        if (offcanvasInstance) offcanvasInstance.hide();
    }
}


document.addEventListener("DOMContentLoaded", ()=>{
    // Video Controls
    const videos = document.querySelectorAll("video");
    if (!videos.length) return;
    videos.forEach((video)=>{
        let videoStarted = false;
        // NOTE: appears unused, leaving as-is to avoid changing behavior elsewhere
        const videoControls = document.getElementById("video-controls");
        const playButton = video.parentNode.querySelector(".video-play");
        if (!playButton) return;
        // Wrapper + poster surface (reliable poster restore on iOS)
        const wrap = video.closest(".video-wrap") || video.parentNode;
        const posterUrl = video.getAttribute("poster");
        if (wrap && posterUrl) {
            wrap.style.setProperty("--video-poster", `url("${posterUrl}")`);
            wrap.classList.add("has-poster", "show-poster");
        }
        function showPosterSurface() {
            if (wrap && posterUrl) wrap.classList.add("show-poster");
        }
        function hidePosterSurface() {
            if (wrap && posterUrl) wrap.classList.remove("show-poster");
        }
        // State sync:
        // - Playing: show native controls, hide overlay, hide poster surface
        // - Paused mid-video: keep native controls ON (so scrubbing works), hide overlay
        // - At start (t=0) or ended: hide native controls, show overlay, show poster surface
        function syncUI() {
            const atStart = video.currentTime === 0 && (video.paused || video.ended);
            const atEnd = !!video.ended;
            if (!video.paused && !video.ended) {
                // Playing
                hidePosterSurface();
                video.controls = true;
                playButton.classList.add("d-none");
                video.classList.add("pointer");
                return;
            }
            // Paused or ended
            if (atEnd || atStart) {
                // Start/end state: show poster + overlay
                showPosterSurface();
                video.controls = false;
                playButton.classList.remove("d-none");
                video.classList.remove("pointer");
            } else {
                // Paused mid-video: keep controls so user can scrub; hide overlay to avoid blocking / double-play look (iOS)
                hidePosterSurface();
                video.controls = true;
                playButton.classList.add("d-none");
                video.classList.remove("pointer");
            }
        }
        function playVideo() {
            if (!videoStarted) {
                // set video start time to 0, allowing you to specify a poster frame timestamp
                video.currentTime = 0;
                videoStarted = true;
            }
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") playPromise.catch(()=>{
                // If playback fails (policy/error), keep UI usable
                video.controls = false;
                playButton.classList.remove("d-none");
                showPosterSurface();
            });
            syncUI();
        }
        function pauseVideo() {
            video.pause();
            syncUI();
        }
        // Overlay play button toggles play/pause
        playButton.addEventListener("click", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (video.paused || video.ended) playVideo();
            else pauseVideo();
        });
        // Click-to-pause on the video (not fullscreen)
        video.addEventListener("click", ()=>{
            if (!video.paused && video.height < 700) pauseVideo();
        });
        // Keep UI in sync with real video state changes (native controls, keyboard, etc.)
        video.addEventListener("play", syncUI);
        video.addEventListener("pause", syncUI);
        // Ended: reset to poster reliably (esp. iOS)
        video.addEventListener("ended", ()=>{
            videoStarted = false;
            video.pause();
            video.currentTime = 0;
            // Return to poster + overlay state
            video.controls = false;
            playButton.classList.remove("d-none");
            showPosterSurface();
            // Helps poster rendering in some browsers
            video.load();
            syncUI();
        });
        // Standard fullscreen change (most browsers)
        video.addEventListener("fullscreenchange", ()=>{
            // If minimized from fullscreen and paused, resync UI
            if (video.height < 500 && video.paused) syncUI();
        });
        // iOS Safari fullscreen exit (fullscreenchange isn't reliable there)
        video.addEventListener("webkitendfullscreen", ()=>{
            // Just resync; keeps things consistent
            syncUI();
        });
        // Initialize UI state
        video.controls = false;
        syncUI();
    });
});





})();
//# sourceMappingURL=main.js.map
